import React, { useState } from 'react';
import { Stack, Inline } from '@/Components/ui/layout';
import { Heading, Text } from '@/Components/ui/typography';
import { Input } from '@/Components/ui/input';
import { Button } from '@/Components/ui/button';
import { Badge } from '@/Components/ui/badge';
import { X, Plus } from 'lucide-react';
import { toast } from 'sonner';

function Skills({ skills, setSkills }) { 
  const [newSkill, setNewSkill] = useState(''); 

  const handleAddSkill = () => {
    if (newSkill.trim() === '') {
      toast.error('Please enter a skill.');
      return; 
    }
    if (skills.includes(newSkill.trim())) {
      toast.error('This skill is already added.');
      return; 
    }
    if (skills.length >= 10) {
      toast.error('You can only add up to 10 skills.');
      return;
    }
    setSkills([...skills, newSkill.trim()]); 
    setNewSkill('');

    // Debug log removed — was leaking user skills to console.
  };

  const handleRemoveSkill = (index) => {
    const updatedSkills = skills.filter((_, i) => i !== index);
    setSkills(updatedSkills); 
  };

  return (
    <section className="flex flex-col items-start w-[106%] p-5 text-slate-300 -mt-7.5">
      <Stack spacing="xs" className="mt-5 items-start">
        <Heading level="h2" size="2xl" className="self-start font-semibold text-slate-400 ml-3">
          Skills
        </Heading>
        <Text size="lg" className="font-normal text-slate-500 max-w-[600px] leading-relaxed ml-3.5 -mt-2.5">
          We recommend adding your top 10 skills used in this role.
        </Text>
      </Stack>
      <Inline spacing="sm" className="w-full max-w-[600px] gap-2.5 items-center mt-[-6px] ml-3.5">
        <Input
          type="text"
          id="skills"
          name="skills"
          placeholder="Enter a skill..."
          value={newSkill} 
          onChange={(e) => setNewSkill(e.target.value)} 
          className="w-[45%] text-base py-2.5 px-2.5 border border-slate-700 rounded-lg bg-transparent text-slate-900"
        />
        <Button 
          className="flex justify-center items-center gap-2.5 rounded-lg bg-gradient-to-r from-green-600 via-green-400 to-green-600 text-base font-semibold py-2.5 px-4 border-none text-white cursor-pointer transition-all hover:from-green-500 hover:via-green-300 hover:to-green-500"
          onClick={handleAddSkill}
        >
          <Plus className="w-[18px] h-[18px]" />
          Add skill
        </Button>
      </Inline>
      <ul className="w-full max-w-[600px] list-none p-0 m-5 mt-0 ml-3.5">
        {Array.isArray(skills) && skills.map((skill, index) => (
          <li key={index} className="flex justify-between items-center bg-slate-700 py-2.5 px-4 rounded-lg mb-2.5">
            <span className="text-slate-200 text-base">{skill}</span>
            <Button 
              variant="ghost"
              size="sm"
              className="bg-transparent text-red-400 border-none text-sm cursor-pointer font-bold transition-colors hover:text-red-500 p-0 h-auto"
              onClick={() => handleRemoveSkill(index)}
              aria-label={`Remove skill ${skill}`}
            >
              <X className="w-4 h-4" />
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Skills;
